import { Button, Paragraph, TrashCanIcon } from "@datagame/ui";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState } from "react";

import { Accordion } from "../../../shared/ui/Accordion";
import { useUser } from "../../../../hooks/user";
import { isAdmin } from "../../../../utils/user/isAdmin";
import { DeleteUserModal } from "../../../shared/modals/DeleteUserModal";

import styles from "./DeleteAccountForm.module.scss";

export const DeleteAccountForm = () => {
  const { t } = useTranslation();
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false);

  const { user } = useUser();

  const isAdminUser = isAdmin(user?.role);

  const renderContent = () => {
    if (isAdminUser) {
      return (
        <>
          <Trans i18nKey={t("profile:deleteAccountSection.warning")} />
          <ul className={styles.list}>
            <li>
              <Trans i18nKey={t("profile:deleteAccountSection.warningInfo1")} />
            </li>
            <li>
              <Trans i18nKey={t("profile:deleteAccountSection.warningInfo2")} />
            </li>
            <li>
              <Trans i18nKey={t("profile:deleteAccountSection.warningInfo3")} />
            </li>
          </ul>
          {t("profile:deleteAccountSection.warningMoreText")}&nbsp;
          <Link className={styles.link} to="/company">
            {t("profile:deleteAccountSection.company")}
          </Link>
          &nbsp;
          {t("profile:deleteAccountSection.panel")}
        </>
      );
    }

    return <Trans i18nKey={t("profile:deleteAccountSection.warningNonAdmin")} />;
  };

  return (
    <>
      <Accordion title={t("profile:deleteAccountSection.showDetails")}>
        <Paragraph size="small">{renderContent()}</Paragraph>

        <Button
          icon={<TrashCanIcon />}
          iconSide="left"
          color="red"
          className={styles.button}
          onClick={() => setIsConfirmDeleteModalOpen(true)}
        >
          {t("profile:deleteAccountSection.title")}
        </Button>
      </Accordion>

      {isConfirmDeleteModalOpen && <DeleteUserModal onClose={() => setIsConfirmDeleteModalOpen(false)} user={user} />}
    </>
  );
};
